import { render, staticRenderFns } from "./ModalDetilsHalls.vue?vue&type=template&id=b5efc038&"
import script from "./ModalDetilsHalls.vue?vue&type=script&lang=js&"
export * from "./ModalDetilsHalls.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetilsHalls.vue?vue&type=style&index=0&id=b5efc038&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports